import React, { useState } from 'react'

import { useT } from '@transifex/react'
import ClusterDoors from '../../Cluster/ClusterDoors'
import '../css/lock.css'
import LockEvents from './LockEvents'
import VendorOnboardingModal from './VendorOnboardingModal'

const Lock = ({ history, controllers, lock, isMobile }) => {
  const t = useT()
  const [showVendorOnboardingModal, setShowVendorOnboardingModal] = useState(false)
  const [currentInflation, setCurrentInflation] = useState('')

  const inflateMode = (mode) => setCurrentInflation((prevMode) => (prevMode === mode ? '' : mode))

  const inflate = (mode) => {
    switch (mode) {
      case 'allocate':
        return <ClusterDoors lock={lock} />
      case 'events':
        return <LockEvents lock={lock} />
      default:
        return null
    }
  }

  const controller = controllers.find((c) => c._id === lock.controller || c._id === lock.carrier_door?.controller)

  const generateBatteryStatusComponent = () => {
    if (controller && controller.hardware_functions) {
      if (controller.hardware_functions.get_battery && controller.hardware_functions.get_battery.active === true) {
        if (controller.hardware_functions.get_battery.min_battery_voltage && controller.hardware_functions.get_battery.max_battery_voltage) {
          if (!controller.hardware_functions.get_battery.latest_value) {
            return <span>{t('Electrical supply:')} -</span>
          }

          let percentage = (controller.hardware_functions.get_battery.latest_value - controller.hardware_functions.get_battery.min_battery_voltage) / (controller.hardware_functions.get_battery.max_battery_voltage - controller.hardware_functions.get_battery.min_battery_voltage)
          percentage = percentage.toFixed(2) * 100
          if (percentage && percentage > 100) percentage = 100
          if (percentage && percentage < 0) percentage = 0
          if (percentage > 33) {
            return (
              <span style={{ color: '#006e78' }}>
                {t('Electrical supply:')} {percentage.toFixed()}%
              </span>
            )
          }
          if (percentage <= 33) {
            return (
              <span style={{ color: 'rgb(187, 16, 16)' }}>
                {t('Electrical supply')} {percentage.toFixed()}%
              </span>
            )
          }
        }
      }
    }
    return null
  }

  return (
    <div style={{ backgroundColor: 'white', marginBottom: 10, borderRadius: 20 }}>
      {showVendorOnboardingModal && <VendorOnboardingModal lock={lock} closeModal={() => setShowVendorOnboardingModal(false)} />}

      <div style={{ display: 'flex', backgroundColor: 'white', borderRadius: 20, paddingBottom: isMobile ? 15 : 15, boxShadow: 'grey 1px 1px 5px' }}>
        <div style={{ flex: 1, padding: 10 }}>
          <p style={{ marginTop: 10 }} className="lock-label">
            <span style={{ fontSize: 16 }} className="lock-name">
              {lock.custom_name}
            </span>
          </p>
          <div>
            <p style={{ marginTop: -5 }}>
              <span className="lock-address">
                {lock.address.street}, {lock.address.zip} {lock.address.city}
              </span>
            </p>
            <p style={{ marginTop: -5 }}>
              <span className="lock-address">{generateBatteryStatusComponent()} &nbsp;</span>
            </p>
            {lock.sub_type === 'container' && (
              <p style={{ marginTop: -5 }}>
                <span className="lock-address">{t('May receive pallets')}</span>
                {lock.settings?.allow_pallet ? ' ✅' : ' ❌'}
              </p>
            )}
            <p style={{ marginTop: -5 }}>
              <span className="lock-address">{lock.accessCode && t('Access code: {accessCode}', lock)} &nbsp;</span>
            </p>
          </div>
        </div>

        <div style={{ paddingTop: 15, display: 'flex', flexDirection: isMobile ? 'column' : 'row', width: '70%', justifyContent: 'flex-end' }}>
          {lock.storage && (
            <div style={{ minWidth: '23%', marginRight: 10 }}>
              <div>
                <p
                  onClick={() => history.push(`/storage/${lock.storage._id}`, { lockId: lock._id })}
                  style={{
                    marginTop: 12,
                  }}
                  className="sub-title-text-container"
                >
                  {t('Manage smart storage')}
                </p>
              </div>
            </div>
          )}

          {lock.type === 'cluster' && (
            <div style={{ minWidth: '25%', marginRight: 10 }}>
              <div>
                <p
                  onClick={() => inflateMode('allocate')}
                  style={{
                    marginTop: 12,
                    border: currentInflation === 'allocate' ? 'none' : '',
                    color: currentInflation === 'allocate' ? '#006e78' : '',
                    backgroundColor: currentInflation === 'allocate' ? '#EDEEF1' : '',
                  }}
                  className="sub-title-text-container"
                >
                  {t('Manage parcel locker')}
                </p>
                <div>{currentInflation === 'allocate' && <span onClick={() => inflateMode('allocate')} className="triangle-down" style={{ left: isMobile ? '43%' : '33%' }}></span>}</div>
              </div>
            </div>
          )}

          <div style={{ minWidth: '25%', marginRight: 10 }}>
            <p
              onClick={() => history.push('/userstab', { lockId: lock._id })}
              style={{
                marginTop: 12,
              }}
              className="sub-title-text-container"
            >
              {t('Manage users')}
            </p>
          </div>
          <div style={{ minWidth: '25%', marginRight: 10 }}>
            <div>
              <p
                onClick={() => inflateMode('events')}
                style={{
                  marginTop: 12,
                  border: currentInflation === 'events' ? 'none' : '',
                  color: currentInflation === 'events' ? '#006e78' : '',
                  backgroundColor: currentInflation === 'events' ? '#EDEEF1' : '',
                }}
                className="sub-title-text-container"
              >
                {t('Events')}
              </p>
              {currentInflation === 'events' && <span className="triangle-down" style={{ left: isMobile ? '43%' : '33%' }}></span>}
            </div>
          </div>

          {lock.createdFromApplication && (
            <div style={{ minWidth: '25%', marginRight: 10 }}>
              <div>
                <p
                  onClick={() => setShowVendorOnboardingModal(true)}
                  style={{
                    marginTop: 12,
                  }}
                  className="sub-title-text-container"
                >
                  {t('Vendors')}
                </p>
                {currentInflation === 'vendors' && <span className="triangle-down" style={{ marginLeft: 'auto', marginRight: 'auto' }}></span>}
              </div>
            </div>
          )}
        </div>
      </div>

      <div>
        <div style={{ marginLeft: 10, marginRight: 10, background: 'transparent' }}>{inflate(currentInflation)}</div>
      </div>
    </div>
  )
}

export default Lock
